<template>
    <div class="card-item schCon"
         style="overflow: scroll"
         :style="{'background-color': type== 'index' ? 'none': '#eef4f9'}">
        <p class="flex-box al-c mb10" style="color: #024A84;">
            <img :src="`${baseUrl}images/${itemData.code}.png`" alt="">
            <span class="ml10 font-14" :style="{'font-size': type == 'index' ? '20px' : '14px'}">日程</span>
            <i class="el-icon-plus" style="padding-left: 10px" @click="addSc" v-if="type != 'index'"></i>
        </p>
        <!--日程内容-->
        <div class="cont">
            <div class="cont_item" v-for="(item, index) in scheduleList" :key="index">
                <div>
                    <p>{{item.type}}</p>
                    <p>{{item.repeatFlagDes}}</p>
                </div>
                <div>
                    <p>{{item.title}}</p>
                    <p>{{item.startTime}} - {{item.endTime}}</p>
                </div>
                <i class="el-icon-error" id="schI" style="position: initial;top: 0;" @click="deleteSch(item)" v-if="type != 'index'"></i>
            </div>
        </div>
        <!--创建日程事件-->
        <el-dialog title="创建日程" :visible.sync="addDateShow"   :modal="false" @close="diaClose">
            <el-form :model="form" :rules="rules" ref="form" >
                <el-form-item label="标题" label-width="120px" prop="title">
                    <el-input v-model="form.title" placeholder="请输入标题"></el-input>
                </el-form-item>
                <el-form-item label="内容" label-width="120px" prop="content">
                    <el-input v-model="form.content" placeholder="请输入内容"></el-input>
                </el-form-item>
                <el-form-item label="类型" label-width="120px" prop="type">
                    <el-select v-model="form.type" placeholder="请选择类型">
                        <el-option label="考试" value="考试"></el-option>
                        <el-option label="活动" value="活动"></el-option>
                        <el-option label="放假" value="放假"></el-option>
                        <el-option label="开学" value="开学"></el-option>
                        <el-option label="选课" value="选课"></el-option>
                        <el-option label="答辩" value="答辩"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="重复" label-width="120px" prop="repeatFlag">
                    <el-select v-model="form.repeatFlag" placeholder="请选择重复频率" @change="flagChange">
                        <el-option v-for="(item,index) in repeatFlagList" :key="index" :label="item.name" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <!--年月日-->
                <el-form-item label="年月日时间段" label-width="120px"  prop="timesYm"  v-if="form.repeatFlag == '0' ">
                    <el-date-picker
                            v-model="form.timesYm"
                            format='yyyy-MM-dd HH:mm'
                            value-format="yyyy-MM-dd HH:mm"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
                <!--时分-->
                <el-form-item v-if="form.repeatFlag == 1 || form.repeatFlag == 2 || form.repeatFlag == 3 || form.repeatFlag == 4" label="时分时间段" label-width="120px"  prop="timesHm">
                    <el-time-picker
                            is-range
                            v-model="form.timesHm"
                            format='HH:mm'
                            value-format="HH:mm"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                    </el-time-picker>
                </el-form-item>
            </el-form>
            <el-form :model="flagForm" :rules="flagRules" ref="flagForm">
                <el-form-item label="每周" label-width="120px" prop="repeatAppendWeeks"  v-if="form.repeatFlag == 2">
                    <el-radio-group v-model="flagForm.repeatAppendWeeks">
                        <el-radio label="1">周一</el-radio>
                        <el-radio label="2">周二</el-radio>
                        <el-radio label="3">周三</el-radio>
                        <el-radio label="4">周四</el-radio>
                        <el-radio label="5">周五</el-radio>
                        <el-radio label="6">周六</el-radio>
                        <el-radio label="7">周日</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="每月" label-width="120px" prop="repeatAppendDays" v-if="form.repeatFlag == 3">
                    <el-input-number v-model="flagForm.repeatAppendDays"  :max="30" :min="1"></el-input-number>
                </el-form-item>
                <el-form-item label="每年" label-width="120px" prop="repeatAppendMonths" v-if="form.repeatFlag == 4">
                    <el-date-picker
                            popper-class="dateTypeCls"
                            format='MM-dd'
                            type="date"
                            placeholder="选择每年频率"
                            v-model="flagForm.repeatAppendMonths"
                            @change="pickChange"
                            style="width: 50%;"></el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitForm('form')">确 定</el-button>
                <el-button @click="addDateShow = false">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {getSchList, addSch, delSch} from '@/api/management/showcase'
    export default {
        name: "Note",
        props:['itemData', 'type'],
        data(){
            return {
                baseUrl: process.env.BASE_URL,
                value: new Date(),
                addDateShow: false,
                scheduleList: [],
                form: {
                    title: '',
                    type: '',
                    timesHm: '', //时分选择
                    timesYm: '', //年月日选择
                    repeatFlag: '',
                    repeatFlagDes: ''
                },
                flagForm: {
                    times: '',
                    repeatAppendWeeks: '',
                    repeatAppendDays: '',
                    repeatAppendMonths: ''
                },
                repeatAppendMonths: '',
                repeatAppendDays: '',
                repeatFlagList: [
                    {
                        value: '0',
                        name: '一次性'
                    },
                    {
                        value: '1',
                        name: '每天'
                    },
                    {
                        value: '2',
                        name: '每周'
                    },
                    {
                        value: '3',
                        name: '每月'
                    },{
                        value: '4',
                        name: '每年'
                    },


                ],
                formLabelWidth: '120px',
                rules: {
                    title: [
                        { required: true, message: '请输入日程标题', trigger: 'blur' },
                        { min: 2, max: 10, message: '长度在 2 到 10 个字符', trigger: 'blur' }
                    ],
                    content: [
                        { required: true, message: '请输入日程内容', trigger: 'blur' },
                    ],
                    type: [
                        { required: true, message: '请选择类型', trigger: 'change' }
                    ],
                    repeatFlag: [
                        { required: true, message: '请选择重复频率', trigger: 'change' }
                    ],
                    timesHm: [
                        {
                            type: 'array',
                            required: true,
                            message: '请选择时分区间',
                            fields: {
                                //tpye类型试情况而定,所以如果返回的是date就改成date
                                0: { type: 'string', required: true, message: '请选择开始时分' },
                                1: { type: 'string', required: true, message: '请选择结束时分' }
                            }
                        }
                    ],
                    timesYm: [
                        {
                            type: 'array',
                            required: true,
                            message: '请选择日期区间',
                            fields: {
                                //tpye类型试情况而定,所以如果返回的是date就改成date
                                0: { type: 'string', required: true, message: '请选择开始日期' },
                                1: { type: 'string', required: true, message: '请选择结束日期' }
                            }
                        }
                    ]
                },
                flagRules: {
                    repeatAppendWeeks: [
                        { required: true, message: '请选择每周频率', trigger: 'change' }
                    ],
                    repeatAppendDays: [
                        { required: true, message: '请输入每月频率', trigger: 'blur' }
                    ],
                    repeatAppendMonths: [
                        { type: 'date', required: true, message: '请选择每年频率', trigger: 'change' }
                    ],
                }
            }
        },
        mounted(){
            if(this.type == 'index') {
                this.scheduleList = this.itemData.data
            }else {
                this.getSchListData()
            }
        },
        methods: {
            getSchListData() {
                let params = {
                    len: 10000,
                    pos: 0
                }
                getSchList(params).then(({data}) =>{
                    if(data.code == 0) {
                         this.scheduleList = data.data
                    }else {
                        this.$message.error(data.msg);
                    }
                })
            },
            flagChange(val){
                this.repeatAppendMonths = ''
                this.repeatAppendDays = ''
                this.flagForm.repeatAppendDays = ''
                this.flagForm.repeatAppendWeeks = ''
                this.repeatFlagList.forEach((item) =>{
                    if(item.value == val) {
                        this.form.repeatFlagDes = item.name
                    }
                })
                this.$refs['flagForm'].resetFields();
            },
            addSc(){
                this.addDateShow = true
            },
            deleteSch(item){
                this.$confirm(`确定删除${item.title}吗`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    delSch(item.id)
                        .then(({data}) => {
                            if(data.code == 0 ){
                                this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                                this.getSchListData()
                            }else {
                                this.$message.error(data.msg)
                            }
                        })
                })
            },
            pickChange(){
                this.repeatAppendMonths = new Date(this.flagForm.repeatAppendMonths).getMonth() + 1
                this.repeatAppendDays = new Date(this.flagForm.repeatAppendMonths).getDate()
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                       if(this.form.repeatFlag == 1 || this.form.repeatFlag == 0) {
                           this.setForm()
                       }
                        if(this.form.repeatFlag == 2 || this.form.repeatFlag == 3 || this.form.repeatFlag == 4 ) {
                            this.flagVali()
                        }
                    } else {
                        return false;
                    }
                });

            },
            flagVali(){
                if(this.form.repeatFlag == 2) {
                    this.$refs['flagForm'].validateField('repeatAppendWeeks', valid => {
                        if (valid) {
                            return;
                        } else {
                            this.setForm()
                        }
                    });
                }
                if(this.form.repeatFlag == 3) {
                    this.$refs['flagForm'].validateField('repeatAppendDays', valid => {
                        if (valid) {
                            return;
                        } else {
                            this.setForm()
                        }
                    });
                }
                if(this.form.repeatFlag == 4) {
                    this.$refs['flagForm'].validateField('repeatAppendMonths', valid => {
                        if (valid) {
                            return;
                        } else {
                            this.setForm()
                        }
                    });
                }
            },
            setForm(){
                let startTime = ''
                let endTime = ''
                if(this.form.repeatFlag == 0) {
                    startTime = this.form.timesYm[0]
                    endTime = this.form.timesYm[1]
                }else {
                    startTime = this.form.timesHm[0]
                    endTime = this.form.timesHm[1]
                }
                let params = {
                    content: this.form.content || '',
                    startTime:startTime || '',
                    endTime: endTime || '',
                    id: '',
                    repeatAppendDays: this.flagForm.repeatAppendDays || this.repeatAppendDays || '',
                    repeatAppendMonths: this.repeatAppendMonths || '',
                    repeatAppendWeeks: this.flagForm.repeatAppendWeeks || '',
                    repeatFlag: this.form.repeatFlag || '',
                    repeatFlagDes: this.form.repeatFlagDes || '',
                    title: this.form.title || '',
                    type: this.form.type || '',
                }
                addSch(params).then(({data}) =>{
                    if(data.code == 0) {
                        this.getSchListData()
                        this.addDateShow = false
                        this.$message.success(  "新增成功!" );
                    }else {
                        this.$message.error(data.msg);
                    }
                })
            },
            diaClose(){
                this.form.title = ''
                this.form.type = ''
                this.form.content = ''
                this.form.timesHm = ''
                this.form.timesYm = ''
                this.form.repeatFlag = ''
                this.form.repeatFlagDes = ''
                this.flagForm.repeatAppendWeeks = ''
                this.flagForm.repeatAppendDays = ''
                this.flagForm.repeatAppendMonths = ''
                this.$refs['form'].resetFields();
            }
        },
    }
</script>

<style scoped lang="less">
    .schCon{
        overflow-x: hidden;
        overflow-y: scroll;
        height: 200px;
    }
    .schCon::-webkit-scrollbar {
        display: none;
    }
.cont{
    /*height: 200px;*/
    /*overflow: scroll;*/
    .cont_item{
        display: flex;
        justify-content: flex-start;
        align-content: center;
        cursor: move;
        div{
            padding: 5px 15px;
            p{
                padding: 4px 0;
            }
        }
        div:nth-child(1){
            width: 25%;
        }
        div:nth-child(2){
            width: 75%;
        }
        #schI{
            /*position: absolute;*/
            display: none;
            right: 10px;
            color: #aaa;
            font-size: 23px;
            cursor: pointer;
        }
    }
    .cont_item:hover {
        box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
        #schI {
            display: block;
        }
    }
}

</style>
<style lang="less">
    .dateTypeCls{
        .el-date-picker__header{
            .el-date-picker__header-label:nth-of-type(1){
                display: none
            }
        }
    }
</style>